import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export const loginSubmit: Types.LoginSubmit = (loginFormFields) =>
Request.requestActionCreator<Types.LoginRequest>(Constants.LOGIN_SUBMIT)({
  method: 'POST',
  payload: loginFormFields,
  url: '/get_token',
})

export const updateLoginField: Types.UpdateFieldFn = ({name, value}) =>
  ({type: Constants.UPDATE_LOGIN_FIELD, field: {name, value}})



// WEBPACK FOOTER //
// ./src/pages/login/actions.ts